import React from "react";
import PropTypes from "prop-types";
import { Button, MenuItem } from "@blueprintjs/core";
import { Select } from "@blueprintjs/select";

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Typography } from '@mui/material';

import "./WebNetSelect.css";


//import { createTheme } from '@material-ui/core/styles';
//import { ThemeProvider, makeStyles} from '@material-ui/styles';


const ItemSelect = ({ items, selectedItem, onSelect, widthX, heightY, label }) => {

    return (

        <Autocomplete
            disablePortal
            value={selectedItem}
            size="small"
            id="combo-box-demo"
            onChange={(event, newvalue) => {
                onSelect(newvalue);
            }}
            options={items}
            disableClearable={true}
            sx={{ width: widthX }}
            renderInput={(params) =>
                <TextField style={{ width: widthX, height: heightY, paddingBottom: 5, marginLeft: 5 }}
                    {...params} />}
        />



    );
    
    //return (
    //    <select
    //        items={items}
    //        itempredicate={(query, item) => {
    //            return item.match(new regexp(`${query}`, "i"));
    //        }}
    //        itemrenderer={(item) => <menuitem onclick={() => onselect(item)} key={item} text={item} />}
    //        noresults={< menuitem disabled={true} text="no results" />}
    //        query=""
    //        onquerychange={() => ""}
    //    >
    //        <button classname="buttonoption" text={selecteditem} righticon="caret-down" />
    //    </select >
    //);

};

ItemSelect.propTypes = {
    items: PropTypes.array.isRequired,
    selectedItem: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
};

export default ItemSelect;
